<div class="calc-bar">

  <!-- Intro -->
  <div class="cb-intro">
    <div class="cb-icon">
      <i class="fa-solid fa-calculator"></i>
    </div>
    <div class="cb-intro-text">
      <strong>{{ 'components.calculator.title' | translate }}</strong>
      <p>{{ 'components.calculator.subtitle' | translate }}</p>
    </div>
  </div>

  <!-- Slider -->
  <div class="cb-slider-section">
    <div class="cb-amount">
      <strong>{{ formatAmount(monthlyIncome) }}€</strong>
      <span>/mes</span>
    </div>
    <input
      type="range"
      class="cb-slider"
      [min]="minIncome"
      [max]="maxIncome"
      step="50"
      [value]="monthlyIncome"
      (input)="onSliderChange($event)"
      [style.--pct]="sliderPercent"
      aria-label="Ingreso mensual objetivo"
    />
    <div class="cb-range-labels">
      <span>{{ formatAmount(minIncome) }}€</span>
      <span>{{ formatAmount(maxIncome) }}€</span>
    </div>
  </div>

  <!-- Results -->
  <div class="cb-results">
    <p class="cb-result-intro">
      {{ 'components.calculator.resultText1' | translate }}
      <strong>{{ formatAmount(monthlyIncome) }}€/mes</strong>
      {{ 'components.calculator.resultMid' | translate }}
    </p>
    <div class="cb-result-bottom">
      <strong class="cb-investment">{{ formatAmount(investmentNeeded) }}€</strong>
      <button class="cb-cta" (click)="openCallModal()">
        <i class="fa-solid fa-phone"></i>
        {{ 'components.calculator.callCta' | translate }}
      </button>
    </div>
    <div class="cb-properties">
      <i class="fa-solid fa-circle-check"></i>
      <span>{{ 'components.calculator.propertiesHint' | translate }}</span>
    </div>
  </div>

</div>
<p class="cb-disclaimer">
  <i class="fa-regular fa-shield-check"></i>
  {{ 'components.calculator.disclaimer' | translate }}
</p>
